import { useTheme } from '@/store/useTheme'
import styles from './HighContrastToggle.module.css'

function ContrastIcon() {
  return (
    <svg
      className={styles.icon}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3v18" />
      <path d="M12 3a9 9 0 0 1 0 18" fill="currentColor" stroke="none" opacity="0.35" />
    </svg>
  )
}

export default function HighContrastToggle() {
  const { highContrast, toggleHighContrast } = useTheme()

  const label = highContrast ? 'High contrast' : 'Default'

  return (
    <button
      type="button"
      className={styles.toggleBtn}
      onClick={toggleHighContrast}
      aria-pressed={highContrast}
      aria-label={highContrast ? 'High contrast on. Switch to default contrast.' : 'Default contrast. Switch to high contrast.'}
      title={highContrast ? 'High contrast (on)' : 'Default contrast'}
    >
      <ContrastIcon />
      <span className={styles.label}>{label}</span>
    </button>
  )
}
